import { drawWithImagePattern, drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const indexFingerPad = async (
  ctx: CanvasRenderingContext2D,
  fingerPadColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  const drawPad = () => {
    ctx.lineWidth = 1.0
    ctx.beginPath()
    ctx.moveTo(378, 358)
    ctx.quadraticCurveTo(385, 278, 398, 240)
    ctx.quadraticCurveTo(405, 210, 435, 205)
    ctx.quadraticCurveTo(458, 213, 455, 241)
    ctx.quadraticCurveTo(436, 361, 436, 361)
    ctx.quadraticCurveTo(406, 350, 378, 358)
    ctx.fill()
    ctx.strokeStyle = '#3b3b3b'
    ctx.stroke()
    ctx.closePath()
  }
  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawPad, fingerPadColor)
  // stitch
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(383, 354)
  ctx.quadraticCurveTo(385, 290, 404, 235)
  ctx.quadraticCurveTo(412, 212, 435, 211)
  ctx.quadraticCurveTo(445, 212, 451, 229)
  ctx.quadraticCurveTo(432, 356, 432, 356)
  ctx.moveTo(387, 352)
  ctx.quadraticCurveTo(387, 290, 408, 235)
  ctx.quadraticCurveTo(414, 214, 435, 215)
  ctx.quadraticCurveTo(443, 214, 447, 231)
  ctx.quadraticCurveTo(430, 354, 428, 354)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
